import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  topnav: {
    background: theme.palette.background.gradient || theme.palette.background.topheaderbg,
    backdropFilter: "blur(8px)",
    transition: "background 0.3s ease",
  },

  menubox: {
    background: theme.palette.background.menubg,
    borderRadius: "10px",
    transition: "all 0.2s ease",
  },
  menuboxtext: {
    background: theme.palette.text.menutext,
  },
  menubar: {
    background: theme.palette.background.menubg,
    borderRadius: "10px",
    "& ul": {
      "& li": {
        "& a": {
          color: theme.palette.text.menutext,
          transition: "color 0.15s ease",
          "&:hover": {
            color: theme.palette.text.primary,
          },
        },
      },
    },
  },
  logout: {
    color: theme.palette.text.topheadertext,
    textTransform: "capitalize",
    cursor: "pointer",
    position: "relative",
    alignItems: "center",
    width: "200px",
    paddingBottom: "37px",
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 0.9,
    },
    "& p": {
      width: "100%",
      textAlign: "right",
      position: "absolute",
      top: "9px",
      fontWeight: 500,
      letterSpacing: "-0.01em",
    },
    "&:hover ul": {
      display: "block",
      animation: "fadeInDown 0.2s ease-out",
    },
    "& ul": {
      width: "220px",
      right: "0px",
      display: "none",
      position: "absolute",
      background: theme.palette.background.paper,
      top: "24px",
      zIndex: 9999,
      boxShadow: "0 10px 40px -5px rgba(60, 90, 152, 0.2)",
      padding: "8px 0",
      listStyle: "none",
      borderRadius: "12px",
      border: `1px solid ${theme.palette.divider}`,
      backdropFilter: "blur(10px)",
      overflow: "hidden",

      "&::after": {
        content: '" "',
        position: "absolute",
        right: "20px",
        top: "-8px",
        borderTop: "none",
        borderRight: "10px solid transparent",
        borderLeft: "10px solid transparent",
        borderBottom: `10px solid ${theme.palette.background.paper}`,
      },
      "& li": {
        padding: "10px 16px",
        borderBottom: `1px solid ${theme.palette.divider}`,
        textAlign: "left",
        color: theme.palette.text.primary,
        fontSize: "14px",
        fontWeight: 500,
        transition: "all 0.15s ease",
        cursor: "pointer",
        "&:last-child": {
          borderBottom: "none",
        },
        "&:hover": {
          backgroundColor: theme.palette.mode === 'dark' 
            ? "rgba(91, 122, 184, 0.15)" 
            : "rgba(60, 90, 152, 0.08)",
          paddingLeft: "20px",
          color: theme.palette.mode === 'dark' ? "#93c5fd" : "#3c5a98",
        },
        "& a": {
          textDecoration: "none",
          color: "inherit",
          display: "block",
          width: "100%",
        },
      },
    },
  },
}));
